module.exports = __webpack_public_path__ + "static/media/early-version-3.91ae61fb.png";